import type { ReactNode } from 'react';

export const symbol_location_chip: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M480-320q4 0 13-8l3-6q16-32 44-55t48-52q11-17 16.5-35.5T610-515q0-53-38-89t-92-36q-54 0-92.5 36T349-515q0 20 6 38.5t17 35.5q20 29 47.5 52t43.5 55l3 6q1 2 14 8Zm-35.5-154.5Q430-489 430-510t14.5-35.5Q459-560 480-560t35.5 14.5Q530-531 530-510t-14.5 35.5Q501-460 480-460t-35.5-14.5ZM320-200q-117 0-198.5-81.5T40-480q0-117 81.5-198.5T320-760h320q117 0 198.5 81.5T920-480q0 117-81.5 198.5T640-200H320Zm0-60h320q92 0 156-64t64-156q0-92-64-156t-156-64H320q-92 0-156 64t-64 156q0 92 64 156t156 64Zm160-220Z"
		/>
	</svg>
);
